/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILinkedContainerProps } from './linked-container.props.autogenerated';
import { ILinkedContainerData } from './linked-container.data';
import classnames from 'classnames';

const LinkedContainer: React.FC<ILinkedContainerProps<ILinkedContainerData>> = props => {
    const { slots, id, config } = props;
    return (
        <div id={config.anchorID || id} className={classnames('linked-container', config.className)}>
            {slots.content.map((children: React.ReactNode, index: number) => (
                <React.Fragment key={index}>{children}</React.Fragment>
            ))}
        </div>
    );
};

export default LinkedContainer;
